import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../../../../../themes/Colors";

const PromotionCard = ({
  date,
  onClick,
  name,
  createdBy,
  category,
  description,
  discountAmount,
  status,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
      style={{
        minHeight: 320,
        paddingTop: 10,
        paddingBottom: 10,
        width: 410,
        borderStyle: "solid",
        margin: 10,
        borderWidth: hover ? 4 : 1,
        display: "flex",
        flexDirection: "column",
        borderRadius: 4,
        position: "relative",
        cursor: "pointer",
        borderColor: hover ? BlackAndWhite.red : BlackAndWhite.primary,
        WebkitBoxShadow: hover ? "0px 0px 7px 2px #00000030" : null,
        // transition: "all 0.05s",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            // marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          Promotion name
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 18,
            // opacity: 0.7,
            width: "70%",
          }}
        >
          {name}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          date created
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 18,
            // opacity: 0.7,
          }}
        >
          {String(date).substring(0, 17)}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          Category
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 18,
            // opacity: 0.7,
          }}
        >
          {category}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          Description
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 16,
            // opacity: 0.7,
            minHeight: 75,
            overflow: "hidden",
            width: "90%",
          }}
        >
          {description}
          {/* even more text must be
            added extra longsome more text is needed here */}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          Discount amount
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 38,
            // opacity: 0.7,
          }}
        >
          R {discountAmount}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: 10,
          right: 10,
        }}
      >
        <div
          style={{
            // marginTop: 10,
            // marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
            width: "100%",
            textAlign: "right",
          }}
        >
          Created by
        </div>
        <div
          style={{
            marginTop: 3,
            // marginLeft: 10,
            fontWeight: "bold",
            fontSize: 14,
            // opacity: 0.7,
            width: "100%",
            textAlign: "right",
          }}
        >
          {createdBy}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          bottom: 10,
          right: 10,
        }}
      >
        <div
          style={{
            // marginTop: 10,
            // marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
            width: "100%",
            textAlign: "right",
          }}
        >
          Status
        </div>
        <div
          style={{
            marginTop: 3,
            // marginLeft: 10,
            fontWeight: "bold",
            fontSize: 14,
            // opacity: 0.7,
            width: "100%",
            textAlign: "right",
          }}
        >
          {status}
        </div>
      </div>
    </div>
  );
};

export default PromotionCard;
